import { Web3Resolver } from "web3-domain-resolver";
import { createThirdwebClient } from "thirdweb";
import { polygon } from "thirdweb/chains";
import { getContract } from "thirdweb";
import { readContract } from "thirdweb";
import { ethers } from "ethers";
import { ConnectionLibrary } from "web3-domain-resolver";
import { NetworkName } from "web3-domain-resolver";

import getProvider from "../lib/web3Provider";
import web3Config from "../web3-config";

async function checkDomainAvailability(fullname) {
  try {
    fullname = fullname.toLowerCase();
    console.log("checkDomainAvailability:" + fullname);


    if (!fullname || typeof fullname !== "string") {
      return res.status(400).json({ message: "Missing or invalid domain name", data: null, error: true });
    }

    let domain = fullname.toLowerCase();
    let isAvailableInContract = false;
    let resolvedDomain;
    let available = false;

    const provider = await getProvider();


    try {
      const contract = new ethers.Contract(web3Config.CONTRACT_ADDRESS, web3Config.CONTRACT_ABI, provider);
      isAvailableInContract = await contract.isDomainAvailable(domain);
      console.log("isAvailableInContract:", isAvailableInContract);

      // Web3Resolver section with error handling
      // try {
      //   const networkConnection = {
      //     networkName: NetworkName.AURORA,
      //     rpcUrl: "https://mainnet.aurora.dev",
      //   };
      //   const connectionLibrary = new ConnectionLibrary([networkConnection]);
      //   const web3resolver = new Web3Resolver(connectionLibrary);
      //   resolvedDomain = await web3resolver.resolve(domain);
      //   console.log("Resolved domain:", resolvedDomain);


      // } catch (resolverError) {
      //   console.error("Web3Resolver error:", resolverError.message);
      //   resolvedDomain = "RESOLUTION_FAILED";
      // }

      available = false;
      if (!isAvailableInContract) {
        available = false;
      } else if (resolvedDomain === undefined || resolvedDomain === null) {
        available = true;
      } else {
        available = false;
      }
    } catch (error) {
      console.error("Default RPC ethers.js attempt failed:", error);
    }

    return available;
  } catch (globalError) {
    console.error("Global error in checkDomainAvailability:", globalError.message);
    throw new Error("Domain availability check failed completely");
  }
}

export default checkDomainAvailability;
